<template>
  <component :is="layout">
    <router-view />
  </component>
</template>
<script>

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      default_layout: "default",
    };
  },
  computed: {
    layout() {
      // if (this.$route.meta.layout === this.default_layout) {
      //   return this.default_layout + "-layout";
      // }
      return (this.$route.meta.layout || this.default_layout) + "-layout";
    },
  },
  watch: {
    '$route'() {
      this.isModalOff();
      console.log('We are in route', this.$route);
    },
  },
  created() {
    this.$store.dispatch('auth/silentlyLoginTimeout');
  },
  mounted() {
    const flashMessage = this.$sCache.get('flash-message');
    if (flashMessage !== null) {
      const type = flashMessage.type ? `$${flashMessage.type}`: '$warning';
      this[type](flashMessage.message);
      this.$sCache.clear('flash-message');
    }
  },
};
</script>

<style lang="scss">
  @import "./assets/scss/main.scss";
</style>
